var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.animateName}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"animate-box-container",style:(_vm.getContainerStyle())},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }